import React from "react";
import { Link } from "react-router-dom";
import Reveal from "@/components/site/Reveal";
import Badge from "@/components/site/Badge";
import ImageCarousel, { pickImages } from "@/components/site/ImageCarousel";
import { useSiteContent, resolveImageUrl } from "@/lib/siteContent";
import { useSeo } from "@/lib/useSeo";
import { PageHeader } from "./AboutPage";

export default function ThemesPage() {
  const { content, loading } = useSiteContent();
  useSeo("Themes", "Themes");
  if (loading || !content) return null;
  return (
    <div data-testid="themes-page">
      <PageHeader title="Themes" script="Themes" subtitle="Every theme styled in lush, luxurious detail." />
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {(content.themes || []).map((t, i) => (
            <Reveal key={t.id || i} delay={(i % 3) * 100}>
              <div className="rounded-3xl overflow-hidden bg-white shadow-cozy hover:shadow-cozy-lg transition-all hover:-translate-y-1 border border-cozy-gold/10" data-testid={`theme-${t.id}`}>
                <div className="relative">
                  <Badge text={t.badge} style={t.badgeStyle || "pill"} />
                  <ImageCarousel images={pickImages(t)} alt={t.name} aspect="aspect-[4/5]" />
                </div>
                <div className="p-7">
                  <h3 className="font-serif text-2xl">{t.name}</h3>
                  <p className="text-cozy-brown-soft text-sm mt-2 leading-relaxed">{t.description}</p>
                  <Link to={`/booking?theme=${t.id}`} data-testid={`theme-book-${t.id}`} className="mt-5 inline-flex px-5 py-2.5 rounded-full bg-cozy-brown text-cozy-bg text-sm hover:bg-cozy-brown-soft transition">
                    Book This Theme
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
